import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';
import {
  ACCOUNT_ADDRESS_BOOK_LINK,
  ACCOUNT_INFORMATION_LINK,
  ORDER_HISTORY_LINK
} from '~shared/constants/links.constants';

export class GATrackingUserAccountMenuClickEvent implements GATrackingEvent {

  constructor(private link: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.NavigationUserAccountMenuClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      label: this.getMenuItemTrackingLabel() || this.link
    };
  }

  private getMenuItemTrackingLabel(): string | null {
    switch (this.link) {
      case ORDER_HISTORY_LINK:
        return 'User Orders Page';
      case ACCOUNT_INFORMATION_LINK:
        return 'User Account Information Page';
      case ACCOUNT_ADDRESS_BOOK_LINK:
        return 'User Address Book Page';
      default:
        return null;
    }
  }
}
